export default __webpack_public_path__ + "static/media/tylerrake002.1ccb9101.jpeg";